export const DescriptionText = () => {
  return (
    <div className="mx-auto mt-10 text-4xl md:text-6xl">
      <span className="block pl-5 md:pl-10">I AM DŽIUGAS PETKŪNAS, </span>
      <span className="block pl-20 md:pl-60 mt-5">I GO BY JOY.</span>
      <span className="block pl-5 md:pl-10 mt-5">BORN IN KAUNAS,</span>
      <span className="block pl-20 md:pl-60 mt-5">LIVING IN KAUNAS, LT.</span>
    </div>
  );
};
